import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "loading",
    initialState: false,
    reducers: {
        set: (state, action) => action.payload,
    },
});
